<h1 mat-dialog-title>Add New User</h1>
<div mat-dialog-content>
  <form>
    <mat-form-field style="width: 100%">
      <mat-label>User Email Address</mat-label>
      <input
        matInput
        name="emailAddress"
        [(ngModel)]="emailAddress"
        type="email"
      /> </mat-form-field
    ><br />
    <mat-form-field style="width: 100%">
      <mat-select [(value)]="userType">
        <mat-option value="1">Designer User</mat-option>
        <mat-option value="0">No Role</mat-option>
        <mat-option value="2">Dashboard User</mat-option>
        <mat-option value="3">Report User</mat-option>
        <mat-option *ngIf="showConsultingUser" value="4">Consulting User</mat-option>
      </mat-select>
      <mat-label>User Type</mat-label>
    </mat-form-field>
    <ng-container>
      <mat-checkbox name="userManager" [(ngModel)]="userManager"
        >Manage Users?</mat-checkbox
      > </ng-container
    ><br />
    <ng-container>
      <mat-checkbox name="invoiceManager" [(ngModel)]="invoiceManager"
        >Manage Invoices?</mat-checkbox
      > </ng-container
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="piButton"
    (click)="onConfirmClick()"
    cdkFocusInitial
  >
    Add User
  </button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">
    Cancel
  </button>
</div>
